import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class StrategyBuilderService {

    constructor(public http: HttpClient, public AppConfig: AppConfig){}

    getMockDetails(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/mock/get?query='+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  getMockDataFromMocks(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/mock/v1/analytics/'+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  importMockData(id:any, reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/generate/automate/strategy/'+id, reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }


  getStrategyBuilder(reqData: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  // return this.http.post('https://itech-api.dev.iquanta.in/api/cat-strategy/v1/add/basic/'+reqData.mbrId, reqData, httpOptions)
  //   .pipe(map((response: any) => response));
      return this.http.post('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/add/basic/'+reqData.mbrId, reqData, httpOptions)
    .pipe(map((response: any) => response));
}

getUserStrategyData(reqData: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/retrieve/basic/'+reqData, httpOptions)
    .pipe(map((response: any) => response));
}

updateStrategyBuilder(reqData: any, id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.patch('https://itech-api.dev.iquanta.in/api/cat-strategy/v1/update/basic/'+id, {dateWiseSubjectReport: reqData} , httpOptions)
    .pipe(map((response: any) => response));
}

  getOtp(email: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.post('https://adminapi.iqmock.iquanta.in/business/otp/' + email, {}, httpOptions)
      .pipe(map((response: any) => response));
  }

   getProfile(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'user_get', httpOptions)
      .pipe(map((response: any) => response));
  }

  uploadUserScoreCard(reqObj:any) {
  return this.http.post('https://itech-api-prod.iquanta.in/api/upload/v1/file', reqObj)
    .pipe(map((response: any) => response));
}

getAnalysisDataMock(id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/analytic/mock/'+id,  httpOptions)
    .pipe(map((response: any) => response));
}


getOverviewResponse(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/indra-ai/v1/bot/query/sendQuery', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

getQuestions(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/generate/automate/strategy-by-mock/'+reqObj.id+'/'+reqObj.mock, {}, httpOptions)
    .pipe(map((response: any) => response));
}

}